import { createSelector } from '@ngrx/store';

import { settingsFeature } from './feature';

const {
  selectAddress,
  selectCompanyInfo,
  selectSoilInfo,
  selectAppSettings,
  selectLocations,
  selectSelectedLocation,
} = settingsFeature;

const selectFocusSettings = createSelector(
  selectAppSettings,
  (appSettings) => appSettings?.focusSettings,
);

const selectIsOnboardingCompleted = createSelector(
  selectAddress,
  selectCompanyInfo,
  selectSoilInfo,
  selectFocusSettings,
  (address, companyInfo, soilInfo, focusSettings) =>
    !!(address && companyInfo && soilInfo && focusSettings),
);

const selectHasLocations = createSelector(
  selectLocations,
  selectSelectedLocation,
  (locations, selectedLocation) =>
    locations === undefined
      ? false
      : locations.length > 0 || selectedLocation !== undefined,
);

const SettingsSelectors = {
  selectAddress,
  selectCompanyInfo,
  selectSoilInfo,
  selectAppSettings,
  selectFocusSettings,
  selectIsOnboardingCompleted,
  selectSelectedLocation,
  selectHasLocations,
  selectLocations,
};

export default SettingsSelectors;
